// ============================================================================
// FILE: src/modules/ppe/pages/masters/sku-attributes/AttributeValueManager.js
// ============================================================================

import React, { useEffect, useState } from "react";
import skuAttributeService from "./skuAttributeService";

const AttributeValueManager = ({ attributeId }) => {

  const [value, setValue] = useState("");
  const [values, setValues] = useState([]);
  const [loading, setLoading] = useState(false);

  // ============================================================
  // FETCH VALUES (FOR EDIT MODE)
  // ============================================================
  useEffect(() => {
    const fetchValues = async () => {
      try {
        const res = await skuAttributeService.getAttributeValues(attributeId);

        if (res.success) {
          setValues(res.data || []);
        }
      } catch (err) {
        console.error("Error fetching values", err);
      }
    };

    if (attributeId) {
      fetchValues();
    }
  }, [attributeId]);

  // ============================================================
  // ADD VALUE
  // ============================================================
  const handleAddValue = async () => {

    if (!value.trim()) {
      alert("Value cannot be empty");
      return;
    }

    try {
      setLoading(true);

      const res = await skuAttributeService.addAttributeValue(attributeId, {
        value: value.trim()
      });

      if (!res.success) {
        alert(res.message);
        return;
      }

      setValues([
        ...values,
        { value: value.trim() }
      ]);

      setValue("");

    } catch (err) {
      console.error(err);
      alert("Error adding value");
    } finally {
      setLoading(false);
    }
  };

  // ============================================================
  // DELETE VALUE (UI ONLY)
  // ============================================================
  const handleDelete = (index) => {
    const updated = [...values];
    updated.splice(index, 1);
    setValues(updated);
  };

  // ============================================================
  // UI
  // ============================================================
  return (
    <div className="value-manager">

      <h4 className="section-title">Manage Values</h4>

      {/* INPUT */}
      <div className="value-input-row">
        <input
          className="input"
          placeholder="Enter value"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />

        <button
          className="btn-primary"
          onClick={handleAddValue}
          disabled={loading}
        >
          {loading ? "Adding..." : "Add"}
        </button>
      </div>

      {/* LIST */}
      {values.length === 0 ? (
        <div className="empty">No values added</div>
      ) : (
        <table className="value-table">
          <thead>
            <tr>
              <th>Value</th>
              <th style={{ textAlign: "right" }}>Action</th>
            </tr>
          </thead>

          <tbody>
            {values.map((item, index) => (
              <tr key={item.id || index}>
                <td>{item.value}</td>
                <td style={{ textAlign: "right" }}>
                  <button
                    className="btn-secondary"
                    onClick={() => handleDelete(index)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* STYLES */}
      <style>{`
        .value-manager {
          margin-top: 20px;
        }

        .section-title {
          margin-bottom: 10px;
        }

        .value-input-row {
          display: flex;
          gap: 10px;
          margin-bottom: 12px;
        }

        .input {
          flex: 1;
          padding: 8px;
          border-radius: 6px;
          border: 1px solid #d1d5db;
        }

        .value-table {
          width: 100%;
          border-collapse: collapse;
        }

        .value-table th {
          background: #f3f4f6;
          padding: 8px;
          text-align: left;
        }

        .value-table td {
          padding: 8px;
          border-top: 1px solid #e5e7eb;
        }

        .empty {
          text-align: center;
          padding: 10px;
          color: #6b7280;
        }

        .btn-primary {
          background: #2563eb;
          color: white;
          border: none;
          padding: 8px 12px;
          border-radius: 6px;
          cursor: pointer;
        }

        .btn-secondary {
          background: #e5e7eb;
          border: none;
          padding: 6px 10px;
          border-radius: 6px;
          cursor: pointer;
        }
      `}</style>

    </div>
  );
};

export default AttributeValueManager;